<kpd-detail-entity-tabs
  [facade]="permissionSetFacade"
  [navigatorHelper]="navigatorHelper"
  (close)="onClose()"
  (itemChanged)="onItemChanged($event.item)"
  [updater]="entityUpdater"
  [viewMode]="viewMode"
  [entityTypeName]="'Permission set' | translate"
>
  <kpd-detail-tab [title]="'General' | translate" name="general">
    <ng-template>
      <app-permission-set-details-general
        [item]="currentItem"
        [updater]="entityUpdater"
        (switchMode)="onSwitchMode($event)"
        [keyOfPermissionSetToCopy]="keyOfPermissionSetToCopy"
        (itemChanged)="onItemChanged($event)"
        [canManage]="canManage"
      ></app-permission-set-details-general>
    </ng-template>
  </kpd-detail-tab>
  <kpd-detail-tab
    [title]="'Permissions' | translate"
    name="permissions"
    icon="unlock"
    [badge]="tabLabels.permissionCount.toString()"
    [disabled]="currentItem.isDeleted() || currentItem.isNew()"
  >
    <ng-template>
      <app-permission-set-details-permissions
        [permissionSet]="currentItem"
        (switchMode)="onSwitchMode($event)"
        (permissionCountChanged)="changeTabLabel('permissionCount', $event)"
        [canManage]="canManage"
      ></app-permission-set-details-permissions>
    </ng-template>
  </kpd-detail-tab>
</kpd-detail-entity-tabs>
